import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
})

// — attach token to every request
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token')
  console.log('Attaching token to', config.url, token)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, err => Promise.reject(err))

// — catch 401s and force relogin
apiClient.interceptors.response.use(
  resp => resp,
  error => {
    if (error.response?.status === 401) {
      console.warn('Token expired or invalid, redirecting to login')
      localStorage.removeItem('auth_token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// fetches paginated leads (protected)
export async function fetchLeads(params = {}) {
  const res = await apiClient.get(
    '/neue/admin/leads/fetch-leads',
    { params }
  )
  return res.data      // { data: [...], meta: {…} }
}

// updates a lead by id + updates object (protected)
export async function updateLead(id, updates) {
  const res = await apiClient.patch(
    '/neue/admin/leads/update-lead',
    { id, updates }
  )
  return res.data      // the updated lead object
}

export async function createLead(leadData) {
    const res = await apiClient.post(
      '/neue/admin/leads/create-lead',
      leadData
    )
    return res.data      // the newly created lead object
  }

// fetch comments for a lead
export async function fetchComments(leadId) {
  const res = await apiClient.get(`/neue/admin/leads/${leadId}/comments`)
  return res.data    // expect an array of { id, user, date, text }
}

// post a new comment
export async function postComment(leadId, text) {
  const res = await apiClient.post('/neue/admin/leads/comments', {
    lead_id: leadId,
    comment: text
  })
  return res.data    // expect the created comment
}

// fetch all users for user-id → username mapping
export async function fetchUsers() {
    const res = await apiClient.get('/neue/admin/leads/users')
    return res.data    // expect an array of { id, username }
}
  
// generate email for a lead
export async function generateEmail({ lead, considerations }) {
  const res = await apiClient.post('/neue/admin/leads/generate-email', {
    lead,
    considerations
  });
  return res.data; // expect { email: '...' }
}


// fetch call analytics for dashboard
export async function fetchCallAnalytics(range = 'week') {
  const res = await apiClient.get('/neue/admin/leads/fetch-call-analytics', {
    params: { range }
  })
  return res.data    // { users: {..}, data: {..} }
}

// fetch paginated calls (protected)
export async function fetchCalls(params = {}) {
  const res = await apiClient.get('/neue/admin/leads/fetch-calls', { params })
  return res.data      // { data: [...], meta: {…} }
}

// —––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// PROXY‑AUDIO HELPERS
// —––––––––––––––––––––––––––––––––––––––––––––––––––––––––––


// 2) if you’d rather fetch the blob and turn it into an object URL:
export async function fetchRecording(recordingId) {
  let res =  await apiClient.get(
    `/neue/admin/leads/proxy-audio/${recordingId}`,
  )

  return res.data.url
  // create a local URL that <audio> can play
}